import CancelIconCircle from '@/components/ui/icons/cancel-icon-circle'
import { Dialog, DialogContent } from '../ui/dialog'

interface Props {
  preview: string | null
  onClose: () => void
}

const AttachmentPreview = ({ preview, onClose }: Props) => {
  return (
    <Dialog open={!!preview} onOpenChange={onClose}>
      <DialogContent className='max-w-[90vw] max-h-[90vh] z-91 bg-transparent gap-0 border-none'>
        <div className='grid place-items-center mb-2'>
          <img
            onKeyDown={e => e.key === 'Enter' && onClose()}
            className='w-full h-auto max-h-[75vh] object-contain'
            src={preview ?? ''}
            alt='Preview'
          />
        </div>
        <button
          type='button'
          onClick={onClose}
          className='inline-flex p-2 rounded-full items-center justify-center text-white text-sm font-medium leading-[170%] gap-2 hover:underline'
          aria-label='Close preview'
        >
          <CancelIconCircle className='w-4 h-4' />
          Close preview
        </button>
      </DialogContent>
    </Dialog>
  )
}

export default AttachmentPreview
